import auth from './auth.json'
import common from './common.json'
import errors from './errors.json'
import experienceShell from './experience-shell.json'
import experienceViewOnly from './experience-view-only.json'
import hostReview from './host-review.json'
import login from './login.json'
import luxeSubmissions from './luxe-submissions.json'
import marquee from './marquee.json'
import notFound from './not-found.json'
import photoset from './photoset.json'
import redirect from './redirect.json'
import resetPassword from './reset-password.json'
import roadmaps from './roadmaps.json'
import routeNames from './route-names.json'
import setPassword from './set-password.json'
import subgeo from './subgeo.json'
import vetting from './vetting.json'
import welcome from './welcome.json'

export const en = {
	auth,
	common,
	errors,
	experience_shell: experienceShell,
	experience_view_only: experienceViewOnly,
	host_review: hostReview,
	login,
	luxe_submissions: luxeSubmissions,
	marquee,
	not_found: notFound,
	photoset,
	redirect,
	reset_password: resetPassword,
	roadmaps,
	route_names: routeNames,
	set_password: setPassword,
	subgeo,
	vetting,
	welcome
} as const
